/* ===== CP Mobile Mega Menu ===== */
(function () {
  // Menu videos have no src until their panel is opened, so they never download on page load.
  function loadPanelVideos(panel) {
    if (!panel) return;
    panel.querySelectorAll('video[data-menu-video]').forEach(function (video) {
      try {
        var poster = video.getAttribute('data-poster');
        if (poster) {
          video.setAttribute('poster', poster);
          video.removeAttribute('data-poster');
        }
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.setAttribute('src', source.getAttribute('data-src'));
          source.removeAttribute('data-src');
        });
        video.removeAttribute('data-menu-video');
        video.load();
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
      } catch (error) {
        if (window.console) console.warn('[cp-nav-mobile] video load failed', error);
      }
    });
  }

  function init() {
    var root = document.querySelector('.cpmm');
    if (!root || root.dataset.cpmmInit === '1') return;
    root.dataset.cpmmInit = '1';

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.cpmm__toggle');
      if (!btn || !root.contains(btn)) return;

      var panel = btn.nextElementSibling;
      var open = btn.getAttribute('aria-expanded') === 'true';

      root.querySelectorAll('.cpmm__toggle').forEach(function (b) {
        if (b !== btn) {
          b.setAttribute('aria-expanded', 'false');
          if (b.nextElementSibling) b.nextElementSibling.hidden = true;
        }
      });

      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
      if (panel && !open) loadPanelVideos(panel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Theme Editor re-renders the header section
  document.addEventListener('shopify:section:load', init);
})();